<header class="header" [class.scrolled]="isScrolled" [class.authenticated-mode]="isAuthenticated$ | async">
    <!-- Barra Institucional -->
    <div class="top-bar-institutional">
      <div class="container top-bar-inner">
        <div class="top-links">
          <a class="inst-banner-link" target="_blank" href="https://www.portaltransparencia.cl/PortalPdT/directorio-de-organismos-regulados/?org=FU028" title="Ley de Transparencia - Transparencia Activa">
            <img class="inst-banner-img h-10" src="https://cdaraucania.sfo2.cdn.digitaloceanspaces.com/01.resources/02.cdaraucania/01.img/TA-gris.png" alt="Transparencia Activa">
          </a>
          <a class="inst-banner-link" target="_blank" href="https://www.portaltransparencia.cl/PortalPdT/web/guest/directorio-de-organismos-regulados?p_p_id=pdtorganismos_WAR_pdtorganismosportlet&orgcode=454abfdb625dbcf0fd191e391c8cae77#A6428:formInfo:j_idt266" title="Ley de Transparencia - Solicitud de Información">
            <img class="inst-banner-img h-10" src="https://cdaraucania.sfo2.cdn.digitaloceanspaces.com/01.resources/02.cdaraucania/01.img/SAI-azulpetroleo.png" alt="Solicitud de Información">
          </a>
          <a class="inst-banner-link" target="_blank" href="https://www.leylobby.gob.cl/instituciones/FU028" title="Ley de Lobby">
            <img class="inst-banner-img h-10" src="https://cdaraucania.sfo2.cdn.digitaloceanspaces.com/01.resources/02.cdaraucania/01.img/banner-ley-lobby.jpg" alt="Lobby">
          </a>
        </div>
      </div>
    </div>
    <div class="container">
    <nav class="navbar">
        <div class="left-group">
        <div class="hamburger" [class.active]="isMenuOpen" (click)="toggleMenu()">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="logo" (click)="navigateToHome()">
            <img src="https://cdaraucania.sfo2.cdn.digitaloceanspaces.com/01.resources/02.cdaraucania/01.img/da-logo.png"
                alt="Desarrolla Araucanía">
        </div>
        </div>

        <ul class="nav-menu" [class.active]="isMenuOpen">
            <li><a routerLink="/" (click)="closeMenu()">Inicio</a></li>
            <li *ngIf="(homeData$ | async)?.services?.length"><a routerLink="/" fragment="services" (click)="closeMenu()">Nosotros</a></li>
            <li *ngIf="(homeData$ | async)?.about?.length"><a routerLink="/" fragment="about" (click)="closeMenu()">Propósito</a></li>
            <li *ngIf="(homeData$ | async)?.news?.length"><a routerLink="/news" (click)="closeMenu()">Noticias</a></li>
            <li *ngIf="(homeData$ | async)?.events?.length"><a routerLink="/events" (click)="closeMenu()">Eventos</a></li>
            <li *ngIf="hasGalleries$ | async"><a routerLink="/galleries" routerLinkActive="active" (click)="closeMenu()">Galerías</a></li>
            <li *ngIf="hasTransparency$ | async"><a routerLink="/transparency" routerLinkActive="active" (click)="closeMenu()">Transparencia</a></li>
            <li *ngIf="(homeData$ | async)?.contact?.length"><a routerLink="/" fragment="contact" (click)="closeMenu()">Contacto</a></li>
            
            <!-- Mobile-only Institutional Links -->
            <li class="mobile-only-link"><a target="_blank" href="https://www.portaltransparencia.cl/PortalPdT/directorio-de-organismos-regulados/?org=FU028" class="external-link" (click)="closeMenu()">Transparencia Activa <span class="external-icon">↗</span></a></li>
            <li class="mobile-only-link"><a target="_blank" href="https://www.portaltransparencia.cl/PortalPdT/web/guest/directorio-de-organismos-regulados?p_p_id=pdtorganismos_WAR_pdtorganismosportlet&orgcode=454abfdb625dbcf0fd191e391c8cae77#A6428:formInfo:j_idt266" class="external-link" (click)="closeMenu()">Sol. de Información <span class="external-icon">↗</span></a></li>
            <li class="mobile-only-link"><a target="_blank" href="https://www.leylobby.gob.cl/instituciones/FU028" class="external-link" (click)="closeMenu()">Ley de Lobby <span class="external-icon">↗</span></a></li>
        </ul>

        <!-- Auth Section -->
        <div class="auth-section">
          <!-- Not authenticated -->
          <div *ngIf="!(isAuthenticated$ | async)" class="auth-buttons">
              <button class="btn btn-primary" (click)="login()">Iniciar Sesión</button>
          </div>

          <!-- Authenticated -->
          <div *ngIf="isAuthenticated$ | async" class="auth-buttons authenticated-buttons">
              <button class="btn btn-portal" routerLink="/admin/dashboard" *ngIf="!(isAdminRoute$ | async)">
                <span class="icon">💼</span>
                Ir al Portal
              </button>
              
              <div class="user-menu">
                <div class="user-profile" (click)="toggleUserMenu()">
                  <div class="user-avatar">
                      <span>{{ getUserInitials() }}</span>
                  </div>
                </div>
                
                <div class="user-dropdown" [class.active]="isUserMenuOpen">
                  <div class="user-info">
                      <div class="user-details">
                        <strong>{{ getUserDisplayName() }}</strong>
                        <small>{{ getUserEmail() }}</small>
                      </div>
                  </div>
                  <div class="dropdown-divider"></div>
                  <button class="dropdown-item" (click)="showUserProfile()">
                      <span class="icon">👤</span>
                      Ver Perfil
                  </button>
                  <button class="dropdown-item logout" (click)="logout()">
                      <span class="icon">🚪</span>
                      Cerrar Sesión
                  </button>
                </div>
              </div>
          </div>
        </div>
    </nav>
    </div>
</header>